// src/app/shared/formly-primeng/form-field/form-field.wrapper.ts
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldWrapper, FormlyFieldConfig, FormlyFieldProps as CoreFormlyFieldProps, FormlyModule } from '@ngx-formly/core';

export interface FormlyFieldProps extends CoreFormlyFieldProps {
  hideRequiredMarker?: boolean;
  hideLabel?: boolean;
}

@Component({
  selector: 'formly-wrapper-primeng-form-field',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule
  ],
  template: `
    <div class="field">
      <label [for]="id" class="block" *ngIf="props.label && !props.hideLabel">
        {{ props.label }}
        <span class="required-star" *ngIf="props.required && !props.hideRequiredMarker"> *</span>
      </label>
      
      <ng-container #fieldComponent></ng-container>
      
      <small class="p-error block" *ngIf="showError">
        <formly-validation-message [field]="field"></formly-validation-message>
      </small>
      
      <small class="block" *ngIf="props.description">{{ props.description }}</small>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyWrapperFormField extends FieldWrapper<FormlyFieldConfig<FormlyFieldProps>> {}